const SECTION_KEY_MAP = {
  sobre: "about",
  servicos: "services",
  consorcio: "services",
  financiamento: "services",
  portfolio: "portfolio",
  depoimentos: "testimonials",
  faq: "faq",
  blog: "blog",
  contato: "contact",
};

export function resolveNavLinks(navigation, enabledSections, hasData = {}) {
  if (!navigation || navigation.length === 0) return [];
  
  const links = navigation.slice();

  return links.filter((l) => {
    if (!enabledSections) return true;
    const sectionKey = l.href.replace("#", "");
    const sk = SECTION_KEY_MAP[sectionKey] || sectionKey;
    if (enabledSections[sk] === false) return false;
    // Hide nav link if section has no data
    if (hasData[sk] === false) return false;
    return true;
  });
}
